import { render, staticRenderFns } from "./chaxun.vue?vue&type=template&id=56068341&scoped=true"
import script from "./chaxun.vue?vue&type=script&lang=js"
export * from "./chaxun.vue?vue&type=script&lang=js"
import style0 from "./chaxun.vue?vue&type=style&index=0&id=56068341&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56068341",
  null
  
)

export default component.exports